module.exports = __webpack_public_path__ + "static/media/ice5.f38e1174.webp";